// extracted by mini-css-extract-plugin
export default {"reward":"ChallengeTotalReward_reward__7Bx+B"};